export interface CrudModal {
    shipment: string;
    origin: string;
    finalDestination: string;
    destination: string;
    description: string;
    services: string;
    deliveryAgent: string;
    account: string;
    customerId: string;
    customerName: string;
    startDate: string;
    endDate: string;
    invDate: string;
    organizationId: number | string;
    isRated:string;
    isInvoiced: string;
    shipmentSelectionPreference: string;
    isOverageShipment: '' | 'true' | 'false';
    shipmentOriginCountry: string;
    carrierType: string[];
  }
  
  export const defaultCrudModal: CrudModal = {
    shipment: '',
    origin: '',
    finalDestination: '',
    destination: '',
    description: '',
    services: '',
    deliveryAgent: '',
    account: '',
    customerId: '',
    customerName: '',
    startDate: '',
    endDate: '',
    invDate: '',
    organizationId: '',
    isRated:'',
    isInvoiced: '',
    shipmentSelectionPreference: '',
    isOverageShipment: '',
    shipmentOriginCountry: '',
    carrierType: [],
  };
  
  export interface CrudModalStateModel {
    crudModal: CrudModal;
  }
  
  // Initial state
  export const defaultCrudState: CrudModalStateModel = {
    crudModal: defaultCrudModal,
  };
  